import { render } from "./SponsorshipView.vue?vue&type=template&id=eeab7328"
import script from "./SponsorshipView.vue?vue&type=script&lang=js"
export * from "./SponsorshipView.vue?vue&type=script&lang=js"

import "./SponsorshipView.vue?vue&type=style&index=0&id=eeab7328&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__